import React, { Component } from 'react';
import { AuthorizationService } from "../service/AuthorizationService";
import { ProgressSpinner } from 'primereact/progressspinner';
import { ProgressBar } from 'primereact/progressbar';
import { Panel } from 'primereact/panel';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import config from '../config';

export class RootLogin extends Component {

    constructor() {
        super();
        this.state = {
            loading: true,
            username: '',//'superadmin@gmail.com',
            password: ''//'abCD1234'
        };

        this.authorizationService = new AuthorizationService();
    }

    async componentDidMount() {
        await this.setState({ loading: false, client: this.props.client });
    }

    async login(){
        const { username, password } = this.state;
        try {
            if(username === "" || password === "")
            {
                throw new Error();
            }
            await this.setState({authenticating: true, authenticationFailed: false});
            const user = await this.authorizationService.rootLogin(username, password);
            await this.props.onAuthenticated(user);
        } catch (error) {
            await this.setState({authenticating: false, authenticationFailed: true});
        }
    }

    async requestPasswordReset(){
        const { username } = this.state;
        try {
            if((username || "") === ""){
                await this.setState({authenticating: false, requestPasswordResetOk: false, requestPasswordResetFailed: true, requestPasswordResetFailReason: "Informe seu e-mail"});
            }
            else{
                await this.setState({authenticating: true, requestPasswordResetOk: false, requestPasswordResetFailed: false, requestPasswordResetFailReason: ''});
                const user = await this.authorizationService.requestPasswordReset(username);
                await this.setState({authenticating: false, requestPasswordResetOk: true, requestPasswordResetFailed: false, requestPasswordResetFailReason: ''});
            }
        } catch (error) {
            console.log(error);
            await this.setState({authenticating: false, requestPasswordResetOk: false, requestPasswordResetFailed: true, requestPasswordResetFailReason: error.toString()});
        }
    }

    render() {        
        const logo = 'assets/layout/images/logo.png';

        const { 
            loading, 
            authenticating,
            authenticationFailed,
            requestPasswordResetOk,
            requestPasswordResetFailed,
            requestPasswordResetFailReason
         } = this.state;

        document.title = "Multipla-TI - Portal Power BI";
        document.getElementById("favicon").href = "https://www.multipla-ti.com.br/wp-content/uploads/2018/05/logo_site.jpg";

        if(loading){
            return <div style={{width: '100%', height: '100%', display:'flex', alignItems:'center', justifyContent: 'center'}}>
                <ProgressSpinner strokeWidth="5"/>
            </div>
        }

        return (
            <div style={{width: '100%', height: '100%', margin: 'auto', paddingTop: '200px'}}>
                <Panel style={{width: '400px', margin: 'auto', backgroundColor: '#ffffff'}}>
                        <div className="p-grid">
                            <div className="p-col-12" style={{textAlign: 'center'}}><img alt="Logo" src={logo} /></div>
                            <div className="p-col-12"><b>E-mail</b></div>
                            <div className="p-col-12"><InputText disabled={authenticating} value={this.state.username || ""} onChange={(e) => this.setState({username: e.target.value})} style={{width: '100%'}}/></div>
                            <div className="p-col-12"><b>Senha</b></div>
                            <div className="p-col-12"><Password disabled={authenticating} feedback={false} value={this.state.password || ""} onChange={(e) => this.setState({password: e.target.value})} style={{width: '100%'}}/></div>
                            <div className="p-col-12" style={{textAlign: 'center'}}>
                                <Button 
                                    disabled={authenticating} 
                                    label={"Entrar"}
                                    onClick={() => this.login()}
                                />
                                <Button 
                                    disabled={authenticating} 
                                    label={"Esqueci a senha"}
                                    onClick={() => this.requestPasswordReset()}
                                    style={{marginLeft: '10px'}}
                                />
                                { authenticating && <div style={{marginTop: '10px'}}><ProgressBar mode="indeterminate"/></div> }
                                { authenticationFailed && <><br/><Message severity="error" text={"Credenciais incorretas"} closable={false} style={{marginTop: '10px'}}/></>}
                                { requestPasswordResetFailed && <><br/><Message severity="error" text={requestPasswordResetFailReason} closable={false} style={{marginTop: '10px'}}/></>}
                                { requestPasswordResetOk && <><br/><Message severity="success" text={"Se o e-mail informado for válido, um mensagem com instruções foi enviada."} closable={false} style={{marginTop: '10px'}}/></>}
                            </div>
                        </div>                    
                </Panel>
                <div style={{width: '400px', margin: 'auto', textAlign: 'center'}}>
                {config.label}
                </div>
            </div>
        );
    }
}